export const vendorCreditKeys = {
  all: ["vendor-credits"] as const,
  balances: () => [...vendorCreditKeys.all, "balances"] as const,
  lists: () => [...vendorCreditKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) => [...vendorCreditKeys.lists(), filters] as const,
  details: () => [...vendorCreditKeys.all, "detail"] as const,
  detail: (id: string) => [...vendorCreditKeys.details(), id] as const,
  applications: () => [...vendorCreditKeys.all, "applications"] as const,
  applicationList: (filters: Record<string, unknown>) =>
    [...vendorCreditKeys.applications(), filters] as const,
};
